// 是否是生产环境
const IS_PROD = ['production', 'prod'].includes(process.env.NODE_ENV);
// host  结尾不要有/
export const BASE_URL = 'https://api.tendencytech.uk';// 'http://1.94.221.57:8082';//  